class Extensions {
  static removeWhiteSpace(value) {
    return value.replace(/^\s+|\s+$/g, "");
  }
}

export default Extensions;
